export default "__VITE_ASSET__CFtY9Clt__"